<template>
  <v-btn class="loginButton white--text" color="#0012A6" height="40" :width="width">{{text}}</v-btn>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.loginButton {
  border-radius: 5px;
}
</style>